import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import "./EmailTab.css";
import email_send from "../../asset/image/email_send.svg";
import LabelValueDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';
import email_success from "../../asset/image/email_success.svg";
import email_fail from "../../asset/image/email_fail.svg";
import alert_icon from "../../asset/image/alert_icon.svg";

interface SmtpTestmailDialogProps {
    smtpTestemail: any;
    successFail: boolean;
    email: string;
    recMail: string;
    handleCancelSuccessFail: () => void;
}

const SmtpTestmailDialog = (props: SmtpTestmailDialogProps) => {
    const {smtpTestemail, successFail, email, recMail, handleCancelSuccessFail} = props;

    const element = (
        <div className="padding10">
            {smtpTestemail?.success == true && <img src={email_success} className="testmailStatusImage"></img>}
            {smtpTestemail?.success == false && <img src={email_fail} className="testmailStatusImage"></img>}
            {smtpTestemail?.success !== undefined && <div className="transfer-tab-grid">
                <LabelValueDisplay
                    label="From"
                    value={email}
                />
            </div>}
            {smtpTestemail?.success !== undefined && <LabelValueDisplay
                label="To"
                value={recMail}
            />}
            {smtpTestemail?.success == true && <div className="successFailText">The email has been successfully sent.</div>}
            {smtpTestemail?.success == false && <div className="successFailText">The email could not be sent. Please try again later.</div>}
        </div>
    )
    return(
        <CommonModal
            open={(smtpTestemail?.success !== undefined) && successFail}
            onClose={handleCancelSuccessFail}
            onSave={handleCancelSuccessFail}
            title={"Test Email"}
            saveText={"OK"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"408px"}
            height={"321px"}
            showCancel={false}
            titleWithWarningIcon={smtpTestemail?.success == true}
            titleWithCustomIcon={smtpTestemail?.success == false}
            customIcon={alert_icon}
        />
    )
}

export default SmtpTestmailDialog;